import { Box, Grid, Typography, useMediaQuery } from '@mui/material';
import styles from '../../../assets/styles/componentStyles/scheduleMeetingStyles/channelsItem.module.scss';
import globalStyles from "../../../assets/styles/global.module.scss";
import React from 'react';

interface ChannelItemProps {
    icon: string, 
    label: string, 
    className: any,
    description: string,
} 

const ChannelItem: React.FC<ChannelItemProps> = (props) => { 
    const { icon, label, className, description } = props;

    const breakPoints = {
        flagLaptopScreen: useMediaQuery<boolean>('(min-width: 1000px) and (max-width: 1450px)'),
    }
    
    return (
        <Grid container direction={"column"} gap={"4px"}>
            <Grid item>
                <Grid container alignItems={"center"} gap={"2px"}>
                    <Grid item xs={breakPoints.flagLaptopScreen ? 2 : 1} className={globalStyles.displayFlexStyle}>
                        <img src={icon} alt={label} />
                    </Grid>
                    <Grid item xs={breakPoints.flagLaptopScreen ? 9.5 : 10.5}>
                        <Typography className={styles.channelItemLableText}>
                            {label}
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item>
                <Grid container alignItems={"center"}>
                    <Grid item xs={breakPoints.flagLaptopScreen ? 2 : 1}></Grid>
                    <Grid item xs={breakPoints.flagLaptopScreen ? 9.5 : 10.5}>
                        <Typography className={styles.channelItemLableDescription}>
                            {description}
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )
}

export default ChannelItem